/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */


(function () {
    'use strict';

    // Check to make sure service workers are supported in the current browser,
    // and that the current page is accessed from a secure origin. Using a
    // service worker from an insecure origin will trigger JS console errors. See
    // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
    var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    if ('serviceWorker' in navigator &&
        (window.location.protocol === 'https:' || isLocalhost)) {
        navigator.serviceWorker.register('/service-worker.js')
            .then(function (registration) {
                // updatefound is fired if service-worker.js changes.
                registration.onupdatefound = function () {
                    // updatefound is also fired the very first time the SW is installed,
                    // and there's no need to prompt for a reload at that point.
                    // So check here to see if the page is already controlled,
                    // i.e. whether there's an existing service worker.
                    if (navigator.serviceWorker.controller) {
                        // The updatefound event implies that registration.installing is set:
                        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
                        var installingWorker = registration.installing;

                        installingWorker.onstatechange = function () {
                            switch (installingWorker.state) {
                                case 'installed':
                                    // At this point, the old content will have been purged and the
                                    // fresh content will have been added to the cache.
                                    // It's the perfect time to display a "New content is
                                    // available; please refresh." message in the page's interface.
                                    break;

                                case 'redundant':
                                    throw new Error('The installing ' +
                                        'service worker became redundant.');

                                default:
                                // Ignore
                            }
                        };
                    }
                };
            }).catch(function (e) {
            console.error('Error during service worker registration:', e);
        });
    }

    // Your custom JavaScript goes here

    $("ul.nav-tabs a").click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });


    $(".read-more").click(function () {
        $(".leermas").css({"max-height": 9999});
        $(".read-more").hide();
        $(".read").show();

    });

    $('.logos-reguladores').on('click', function () {
        let href = $(this).data('scroll');
        let tab = $('#reguladores .tabs li a');
        $.each(tab, function (index, element) {
            if ($(element).attr('href') === href) {
                $(element).tab('show');
            }
        });
    });


    $(".read").click(function () {


        $(".leermas").css({"max-height": 300});
        $(".read").hide();
        $(".read-more").show();
    });

    $(window).on('load', function () {
        "use strict";
        /* ----------- Page Loader ----------- */
        $(".loader-item").delay(700).fadeOut();
        $("#pageloader").delay(1000).fadeOut("slow");
        /* ----------- Pretty Photo ----------- */
        $("a[data-rel^='prettyPhoto']").prettyPhoto({
            deeplinking: false,
            allow_resize: true,
            allow_expand: false,
            default_width: 300,
            default_height: 300
        });
        initPortfolioGrid();
    });

    /* ----------- Scroll Navigation ----------- */
    $('.scroll').on('click', function (event) {
        var $anchor = $(this);
        var headerH = $('#navigation-menu').outerHeight();
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 45 + "px"
        }, 1200, 'easeInOutExpo');
        event.preventDefault();
    });

    /* ----------- Animation ----------- */
    $('.animated').appear(function () {
        var elem = $(this);
        var animation = elem.data('animation');
        if (!elem.hasClass('visible')) {
            var animationDelay = elem.data('animation-delay');
            if (animationDelay) {
                setTimeout(function () {
                    elem.addClass(animation + " visible");
                }, animationDelay);
            } else {
                elem.addClass(animation + " visible");
            }
        }
    });


    /* ----------- Active Navigation ----------- */
    $('body').scrollspy({
        target: '#nav',
        offset: 95
    });

    document.querySelector('form').addEventListener('invalid', function (evt) {
        evt.preventDefault();
    }, true);

    $('#contactform :input:not(.btn)').on('focus', function () {
        $(this).removeClass('invalid').parent().find('span').remove();
    }).on('blur', function () {
        if ($(this).val().trim() === '' && $(this).attr('required')) {
            $(this).after('<span class="alert alert-danger" ' +
                'style="margin-top: 10px; display: inline-block; padding: 5px">' +
                'Llena el campo para poder continuar</span>'
            ).addClass('invalid');
        }
    });

    $('#contactform .btn').on('click', function () {
        validate($('#contactform'));
    });

    $('#contactform').on('submit', function () {
        if (validate($(this))) {
            toastr.options = {
                closeButton: true,
                debug: false,
                newestOnTop: false,
                progressBar: false,
                rtl: false,
                positionClass: 'toast-top-full-width',
                preventDuplicates: false,
                onclick: null
            };
            $.post('/sendMail.php',
                $(this).serialize(),
                function () {
                    toastr.success('Gracias por escribirnos');
                }
            ).fail(function () {
                toastr.error('Ha ocurrido un error, favor de intentarlo nuevamente');
            });
        }

        return false;
    });

    function validate(form) {
        var caract = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
        $('#contactform :input:not(.btn)').each(function (index, element) {
            $(element).removeClass('invalid').parent().find('span').remove();
            if ($(element).val().trim() === '' && $(element).attr('required')) {
                $(element).after('<span class="alert alert-danger" ' +
                    'style="margin-top: 10px; display: inline-block; padding: 5px">' +
                    'Llena el campo para poder continuar</span>'
                ).addClass('invalid');
            }
            else if ($(element).is('[type=email]') && !caract.test($(element).val().trim())) {
                $(element).after('<span class="alert alert-info" ' +
                    'style="margin-top: 10px; display: inline-block; padding: 5px">' +
                    'Deberás seguir el siguiente formato para continuar: alguien@ejemplo.com</span>'
                ).addClass('invalid');
            }
            else if ($(element).val().trim().length < 3 && $(element).attr('required')) {
                $(element).after('<span class="alert alert-info" ' +
                    'style="margin-top: 10px; display: inline-block; padding: 5px">' +
                    'El texto introducido no es válido</span>'
                ).addClass('invalid');
            }
            else {
                $(element).removeClass('invalid').parent().find('span').remove();
            }
        });
        return !$('#contactform :input:not(.btn)').hasClass('invalid');
    }


    /* ----------- Menus hide after click -- mobile devices ----------- */
    $('.nav li a').on('click', function () {
        $('.navbar-collapse').removeClass('in');
    });

    /* ========== Background image height equal to the browser height.==========*/
    $('.text-slider,.video-bg').css({'height': $(window).height()});
    $(window).on('resize', function () {
        $('.text-slider,.video-bg').css({'height': $(window).height()});
    });

    /*------Text slider------*/
    $(".home-text-slider").owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 300,
        autoPlay: 5000,
        paginationSpeed: 400,
        singleItem: true,
        pagination: true,
        items: 1
    });


    $(".test-carusel").owlCarousel();

    /*------Text slider 2 ( Without Pagination  )------*/
    $(".home-text-slider2").owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 300,
        autoPlay: 5000,
        paginationSpeed: 400,
        singleItem: true,
        pagination: false,
        transitionStyle: "fade",
        items: 3
    });

    /*------Testimonial slider------*/
    $("#testimonials-slider").owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 300,
        autoPlay: 3000,
        paginationSpeed: 400,
        singleItem: true,
        pagination: true,
        items: 1
    });


    /*------Clients slider------*/
    $("#clients-slider").owlCarousel({
        navigation: true, // Show next and prev buttons
        slideSpeed: 300,
        autoPlay: 3000,
        paginationSpeed: 400,
        singleItem: false,
        pagination: false,
        items: 5,
        itemsDesktop: [1199, 5],
        itemsDesktopSmall: [980, 5],
        itemsTablet: [768, 3],
        itemsTabletSmall: [480, 2],
        itemsMobile: [479, 2]
    });


    /*------Tool Tip-----*/
    $('[data-toggle="tooltip"]').tooltip();

    /* -------- Background Slider -------- */
    $('#slides').superslides({
        inherit_width_from: '.wide-container',
        inherit_height_from: '.wide-container'
    });

    /* -----------------Typed Text Slider-------------- */
    $(".element").each(function () {
        var $this = $(this);
        $this.typed({
            strings: $this.attr('data-elements').split(','),
            loop: true,
            typeSpeed: 100, // typing speed
            backDelay: 3000 // pause before backspacing
        });
    });

    /* ----------- Video Bg ----------- */
    $(".movie").mb_YTPlayer();


    function resetForm($form) {
        $form.find('input:text, input:password, input, input:file, select, textarea').val('');
        $form.find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
        $form.find('.form-control-feedback').css('display', 'none');
    }


    /* ----------- Google Map ----------- */
    function initialize() {
        var myLatlng = new google.maps.LatLng(20.085279, -98.720700);
        var mapOptions = {
            zoom: 15,
            disableDefaultUI: true,
            scrollwheel: false,
            gestureHandling: "cooperative",
            center: myLatlng
        };
        var map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
        var contentString = '<div id="map-content">' +
            '<p>Balmer Car Rental</p>' +
            '<div> Fraccionamiento Loma Escondida, Mineral de la Reforma</div>' +
            '<div> Pachuca de Soto, Hidalgo,</div>' +
            '<div>C.P - 42186 </div>'
        '</div>';
        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });
        var marker = new google.maps.Marker({
            position: map.getCenter(),
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 10
            },
            map: map
        });

        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }

    $('.map').each(function () {
        google.maps.event.addDomListener(window, 'load', initialize);
    });
    //

    // Portfolio Filter Js
    function initPortfolioGrid() {
        $('.project-grid').each(function () {
            var $port_container = $(this);

            var filter_selector = $port_container.parent().find('.project-filters a.active').data('filter');

            let isotop = new Isotope(".project-grid", {
                itemSelector: '.item',
                filter: filter_selector,
                animationEngine: "css",
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });

            // Portfolio Filter Items
            $('.project-filters a').on('click', function () {
                $(this).parent().parent().find('a.active').removeClass('active');
                $(this).addClass('active');
                let selector = $(this).parent().parent().find('a.active').attr('data-filter');
                isotop.arrange({filter: selector});
                return false;
            });
        });
    }

})();

